export default {"src":"/_next/static/media/joignable-purple.08992fb0.svg","height":48,"width":49,"blurWidth":0,"blurHeight":0};